// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3jKMS","actions":"GroupTable_actions__2cq16","deleteModalFooter":"GroupTable_deleteModalFooter__3wYHq"};